exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbnail[data-v-68814f3c]{margin:10px;max-width:50px;display:inline-block;cursor:pointer}.selected[data-v-68814f3c]{border-radius:3px;-webkit-box-shadow:0 0 2px 5px #777;box-shadow:0 0 2px 5px #777}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68814f3c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/Products/ImageGallery.vue
// module id = 2153
// module chunks = 1